import React from "react"
import {Badge} from 'reactstrap';

const PriceModelDisplay = ({model,value}) => {
    return <><Badge color="secondary" className="mr-1 mb-1">{model}</Badge> {" "+((model==='CPA')?"$":"")+value+((model==='REV')?"%":"")}</>
}

export default PriceModelDisplay;
